import FullWidth from '~components/_layout/FullWidth';
import PostContent from '~components/content/PostContent';
import { RouterLocation } from '~globals/interfaces';

export default function PureFullWidthTemplate({
    location,
    data,
}: {
    location: RouterLocation;
    data: IWpPage;
}) {
    return (
        <>
            <FullWidth location={location}>
                <PostContent content={data.content || ''} pathname={location.pathname} />
            </FullWidth>
        </>
    );
}
